import { combineReducers } from '@reduxjs/toolkit'
import gameSetting from './slices/gameSettings.slice'
import authSlice from './slices/auth.slice'
// import crashGame from 'games/CrashGames/slice-thunk/crashGame.slice'
import newCrashGame from './slices/newCrashGame.slice'
import towerGame from './slices/towerGame.slice'

import loader from './slices/loader.slice'

const rootReducer = combineReducers({
  gameSetting,
  // crashGame,
  newCrashGame,
  auth: authSlice,
  towerGame,
  loader
})

export default rootReducer
